import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ElegibilityService } from '../opportunities/elegibility.service';

export const elegibilityResolver: ResolveFn<boolean> = (route, state) => {
  return inject(ElegibilityService).get();
};
